import { useEffect, useState } from "react";
import apiTicket from "../../apis/api.ticket";
import parse from "html-react-parser";
import "./OrderDetail.scss";
import { QRCodeCanvas } from "qrcode.react";
function OrderDetail(props) {
  const [ticketId, setTicketId] = useState(
    props.ticket.ticket_id
  );
  const [ticket, setTicket] = useState(props.ticket ? props.ticket : {});
  const [ticketInfo, setTicketInfo] = useState([]);
  const [moreInfo, setMoreInfo] = useState(false);

  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  const handleClick = () => {
    setMoreInfo(!moreInfo);
  };
  useEffect(() => {
    const getData = async () => {
      const res = await apiTicket.getTicketByTicketId(ticketId);
      if (res) {
        setTicketInfo(res.elements);
      }
    };
    getData();
  }, []);
  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  console.log(ticketInfo)
  return (
    <>
      {ticket ? (
        <>
          <div className="order-detail-background">
            <div className="order-detail">
              <div className="order-detail-content">
                <h3>{ticketInfo.name}</h3>
                <p>Điều kiện: {ticketInfo.required}</p>
                <p>Đơn giá: {numberWithCommas(ticketInfo.price?ticketInfo.price:"0")} VND</p>
                <p>Suất chiếu: {ticket.hour} Ngày {ticket.date.split("T")[0]}</p>
              </div>
              <div className="order-detail-qr">
                <QRCodeCanvas
                  value={`http://localhost:3000/qr/od/${ticket.id}`}
                  size={200}
                  bgColor="#ffffff"
                  fgColor="#000000"
                  level="Q"
                  includeMargin={true}
                />
              </div>
            </div>
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  );
}
export default OrderDetail;
